export default __webpack_public_path__ + "static/media/Account_generator.3bba77d5.jpg";